(() => {
  'use strict';
  const section = document.querySelector('[data-dm-business-request]');
  if (!section) return;
  const key = 'date-me-business-brief-v1';
  const success = section.querySelector('[data-dm-request-success]');
  if (success) {
    try { sessionStorage.removeItem(key); } catch (_) {}
    success.focus();
    return;
  }
  const select = section.querySelector('[data-dm-request-select]');
  if (!select) return;
  const form = select.closest('form');
  function updateFields() {
    const type = select.selectedOptions[0]?.dataset.request || '';
    section.querySelectorAll('[data-dm-request-fields]').forEach(group => {
      const visible = group.dataset.dmRequestFields.split(' ').includes(type);
      group.hidden = !visible;
      group.querySelectorAll('input').forEach(input => { input.disabled = !visible; });
    });
  }
  function choose(type) {
    const option = [...select.options].find(item => item.dataset.request === type);
    if (option) select.value = option.value;
    updateFields();
  }
  try {
    const draft = JSON.parse(sessionStorage.getItem(key) || '{}');
    [...form.elements].filter(el => el.name?.startsWith('contact[')).forEach(el => {
      if (typeof draft[el.name] === 'string' && !el.value) el.value = draft[el.name];
    });
  } catch (_) {}
  const requested = new URLSearchParams(location.search).get('request');
  if (requested) choose(requested); else updateFields();
  form.addEventListener('input', () => {
    const draft = Object.fromEntries([...form.elements].filter(el => el.name?.startsWith('contact[')).map(el => [el.name, el.value]));
    try { sessionStorage.setItem(key, JSON.stringify(draft)); } catch (_) {}
  });
  select.addEventListener('change', updateFields);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-dm-request-type]');
    if (!link) return;
    event.preventDefault();
    choose(link.dataset.dmRequestType);
    section.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
    select.focus({preventScroll:true});
  });
})();
